/* global $:false */

import DetailsWithCachedState from 'src/public/details_with_cached_state.js'
import MarketLotShowBidForm from 'src/public/market_lot_show_bid_form.js'
import MarketLotShowCountdown from 'src/public/market_lot_show_countdown.js'
import PusherClient from 'src/shared/pusher_client.js'
import MarketLotShowBidExplanation from 'src/public/market_lot_show_bid_explanation'

export default class MarketLotShowSidebar {
  static init () {
    if (this.instance) { this.instance.destroy() }
    if ($('.js-market-lot-sidebar').length === 0) { return }
    this.instance = new MarketLotShowSidebar($('.js-market-lot-sidebar').first())
  }

  constructor (el) {
    this.startRefresher = this.startRefresher.bind(this)
    this.refresh = this.refresh.bind(this)
    this.update = this.update.bind(this)
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()

    if (this.refreshIn > -1) {
      this.loadComponents()
      this.startRefresher()
      this.subscribeToUpdates()
    }
  }

  findElements () {
    this.auctionStateHeadlinePartial = this.el.find('.js-market-lot-show-auction-state-headline-container')
    this.biddingEndDatePartial = this.el.find('.js-market-lot-show-bidding-end-date-container')
    this.resultPartial = this.el.find('.js-market-lot-show-result-container')
    this.leaderPartial = this.el.find('.js-market-lot-show-leader-container')
    this.maxbidPartial = this.el.find('.js-market-lot-show-maxbid-container')
    this.bidHistoryPartial = this.el.find('.js-market-lot-show-bid-history-container')
  }

  readDataAttributes () {
    this.refreshIn = this.el.data('refresh-in')
    this.url = this.el.data('url')
    this.channelName = this.el.data('channel')
  }

  loadComponents () {
    this.bidForm = new MarketLotShowBidForm()
    this.bidForm.refreshCallback = this.refresh
    this.timer = new MarketLotShowCountdown()
    this.timer.start()
    this.timer.refreshCallback = this.refresh
  }

  startRefresher () {
    clearTimeout(this.refresher)
    if (this.refreshIn === null) { return }
    if (this.refreshIn < 0) { return }
    this.refresher = setTimeout(() => {
      this.refresh()
    }
    , 1000 * this.refreshIn)
  }

  subscribeToUpdates () {
    const pusher = PusherClient.connection()
    const channel = pusher.subscribe(this.channelName)
    channel.bind('online_bid_placed', () => this.refresh())
  }

  refresh () {
    $.ajax({
      url: this.url,
      dataType: 'json',
      success: data => {
        this.update(data)
        this.startRefresher()
      },
      error: data => {
        if (this.refreshIn < 1) { this.refreshIn = 1 }
        this.refreshIn *= 2 // Exponential backoff
        this.startRefresher()
      }
    })
  }

  update (data) {
    this.refreshIn = data.refresh_in
    this.timer.update(data.seconds_remaining)
    this.bidForm.update(data)

    this.auctionStateHeadlinePartial.html(data.partials.auction_state_headline)
    this.biddingEndDatePartial.html(data.partials.bidding_end_date)
    this.resultPartial.html(data.partials.result)
    this.leaderPartial.html(data.partials.leader)
    this.maxbidPartial.html(data.partials.maxbid)
    this.bidHistoryPartial.html(data.partials.bid_history)

    // Re-binding elements that were created via ajax
    DetailsWithCachedState.setupElement(this.bidHistoryPartial.find('.o-details')[0])
    MarketLotShowBidExplanation.init()
  }

  destroy () {
    const pusher = PusherClient.connection()
    pusher.unsubscribe(this.channelName)
    clearTimeout(this.refresher)
  }
}
